import React, {Fragment} from 'react';
import {getApiUrl} from "../service/Api";
import {GoogleMap, Marker} from "@react-google-maps/api";
import {getIcon} from "../service/Icon";

const VIEW_LETTER_A = 'letterA';
const VIEW_LETTER_B = 'letterB';

class MemberDetail extends React.Component {

    static defaultProps = {
        onClose: () => {
        },
        onNext: () => {
        },
        onPrev: () => {
        },
        handleSidebar: (open) => {
        },
        categories: [],
        member: {},
        selected: 0,
        total: 0,
        version: 'MOBILE'
    }

    constructor(props) {
        super(props);

        this.state = {
            activeView: VIEW_LETTER_A,
            sidebaropen: true,
            map: null,
            direction: {
                origin: null,
                destination: null,
                travelMode: 'DRIVING',
                respoonse: null
            },
            layers: {
                firstLayer: [],
                secondLayer: []
            },
            accordion: {
                firstLayer: [],
                secondLayer: []
            }
        }

        this.xDown = null;
        this.yDown = null;
    }

    componentDidMount() {
        document.addEventListener('touchstart', this.handleTouchStart, false);
        document.addEventListener('touchmove', this.handleTouchMove, false);
        this.bringToTop();
        this.handleLayers();
    }

    componentWillUnmount() {
        document.removeEventListener('touchstart', this.handleTouchStart, false);
        document.removeEventListener('touchmove', this.handleTouchMove, false);
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.member.member_id !== this.props.member.member_id) {
            this.handleLayers();
        }
    }

    handleSidebarDesktop = (event) => {
        event.preventDefault();
        this.setState({
            sidebaropen: (this.state.sidebaropen !== true)
        }, () => {
            this.props.handleSidebar(this.state.sidebaropen);
        });

    }

    showLess = (e, layer, index) => {
        let layerIndex = [...this.state.accordion[layer]];
        const arrayIndex =  layerIndex.indexOf(index);

        if (arrayIndex > -1) { // only splice array when item is found
            layerIndex.splice(arrayIndex, 1); // 2nd parameter means remove one item only
        }

        this.setState({
            accordion: {
                ...this.state.accordion,
                [layer]: layerIndex
            }
        })
    }

    showMore = (e, layer, index) => {

        let layerIndex = [...this.state.accordion[layer]];
        layerIndex.push(index);

        this.setState({
            accordion: {
                ...this.state.accordion,
                [layer]: layerIndex
            }
        })
    }

    handleLayers = () => {

        let firstLayer = [];
        let secondLayer = [];


        if (this.props.member.member_post_content && this.props.member.member_post_content.length > 8) {
            firstLayer.push({
                title: 'Beschreibung',
                content: this.props.member.member_post_content
            })
        }

        if (this.props.member.member_diagnostic_services && this.props.member.member_diagnostic_services.length > 8) {
            firstLayer.push({
                title: 'Diagnostische Leistungen',
                content: this.props.member.member_diagnostic_services
            })
        }

        if (this.props.member.member_work_hours !== null) {
            try {
                let workHours = JSON.parse(this.props.member.member_work_hours);

                if (
                    (workHours['Monday'] !== null && workHours['Monday'].length > 0) &&
                    (workHours['Tuesday'] !== null && workHours['Tuesday'].length > 0) &&
                    (workHours['Wednesday'] !== null && workHours['Wednesday'].length > 0) &&
                    (workHours['Thursday'] !== null && workHours['Thursday'].length > 0) &&
                    (workHours['Friday'] !== null && workHours['Friday'].length > 0) &&
                    (workHours['Saturday'] !== null && workHours['Saturday'].length > 0) &&
                    (workHours['Sunday'] !== null && workHours['Sunday'].length > 0)
                ) {

                    firstLayer.push({
                        direct: true,
                        title: 'Öffnungszeiten',
                        content: <Fragment>
                            <table width="100%" className="profile-table">
                                <tr>
                                    <td>Montag</td>
                                    <td>{(workHours['Monday'] === null || workHours['Monday'].length <= 0 ? '-': workHours['Monday'])}</td>
                                </tr>
                                <tr>
                                    <td>Dienstag</td>
                                    <td>{(workHours['Tuesday'] === null || workHours['Tuesday'].length <= 0 ? '-': workHours['Tuesday'])}</td>
                                </tr>
                                <tr>
                                    <td>Mittwoch</td>
                                    <td>{(workHours['Wednesday'] === null || workHours['Wednesday'].length <= 0 ? '-': workHours['Wednesday'])}</td>
                                </tr>
                                <tr>
                                    <td>Donnerstag</td>
                                    <td>{(workHours['Thursday'] === null || workHours['Thursday'].length <= 0 ? '-': workHours['Thursday'])}</td>
                                </tr>
                                <tr>
                                    <td>Freitag</td>
                                    <td>{(workHours['Friday'] === null || workHours['Friday'].length <= 0 ? '-': workHours['Friday'])}</td>
                                </tr>
                                <tr>
                                    <td>Samstag</td>
                                    <td>{(workHours['Saturday'] === null || workHours['Saturday'].length <= 0 ? '-': workHours['Saturday'])}</td>
                                </tr>
                                <tr>
                                    <td>Sonntag</td>
                                    <td>{(workHours['Sunday'] === null ||  workHours['Sunday'].length <= 0 ? '-': workHours['Sunday'])}</td>
                                </tr>
                            </table>
                        </Fragment>
                    })

                }


            } catch (error) {
            }
        }

        if (this.props.member.member_special_offers && this.props.member.member_special_offers.length > 8) {
            firstLayer.push({
                title: 'Besondere Angebote',
                content: this.props.member.member_special_offers
            })
        }

        if (this.props.member.member_professional_career && this.props.member.member_professional_career.length > 8) {
            secondLayer.push({
                title: 'Beruflicher Werdegang',
                content: this.props.member.member_professional_career,
                accordion: true,
                reference: React.createRef()
            })
        }
        if (this.props.member.member_qualifications && this.props.member.member_qualifications.length > 8) {
            secondLayer.push({
                title: 'Qualifikationen',
                content: this.props.member.member_qualifications,
                accordion: true,
                reference: React.createRef()
            })
        }
        if (this.props.member.member_medical_presentations && this.props.member.member_medical_presentations.length > 8) {
            secondLayer.push({
                title: 'Medizinische Vorträge',
                content: this.props.member.member_medical_presentations,
                accordion: true,
                reference: React.createRef()
            })
        }

        if (this.props.member.member_publications && this.props.member.member_publications.length > 8) {
            secondLayer.push({
                title: 'Veröffentlichungen in medizinischen Fachzeitschriften & Büchern',
                content: this.props.member.member_publications,
                accordion: true,
                reference: React.createRef()
            })
        }

        this.setState({
            activeView: VIEW_LETTER_A,
            layers: {
                firstLayer: firstLayer,
                secondLayer: secondLayer
            }
        }, () => {

            this.handleReadMoreRendering();

        });

    }

    handleReadMoreRendering = () => {
        try {

            window.jQuery('.member-profile-card-accordion').each(function() {
                console.log(window.jQuery(this).find('.member-profile-card-body').height());
                if (window.jQuery(this).find('.member-profile-card-body').height() <= 300) {
                    window.jQuery(this).removeClass('member-profile-card-accordion');
                    window.jQuery(this).find('.readmore').hide();
                } else {
                    window.jQuery(this).find('.member-profile-card-body').css({
                        maxHeight: 300,
                        overflow: 'hidden'
                    })
                }
            })

        } catch (error) {

        }
    }

    handleChangeView = (event, view) => {

        event.preventDefault();
        this.setState({
            activeView: view
        }, () => {
            this.handleReadMoreRendering();
        })

    }

    getTouches = (evt) => {
        return evt.touches ||             // browser API
            evt.originalEvent.touches; // jQuery
    }

    handleTouchStart = (evt) => {

        const firstTouch = this.getTouches(evt)[0];
        this.xDown = firstTouch.clientX;
        this.yDown = firstTouch.clientY;

    }

    handleTouchMove = (evt) => {

        if (!this.xDown || !this.yDown) {
            return;
        }

        var xUp = evt.touches[0].clientX;
        var yUp = evt.touches[0].clientY;

        var xDiff = this.xDown - xUp;
        var yDiff = this.yDown - yUp;

        if (Math.abs(xDiff) > Math.abs(yDiff)) {/*most significant*/
            if (xDiff > 0) {
                this.props.onNext();
            } else {
                this.props.onPrev();
            }
        } else {
            if (yDiff > 0) {
                /* down swipe */
            } else {
                /* up swipe */
            }
        }
        /* reset values */
        this.xDown = null;
        this.yDown = null;

    }

    bringToTop = () => {
        try {
            window.scrollTo(0, 0);
        } catch (error) {

        }
    }

    handlePrev = (event) => {
        event.preventDefault();
        this.bringToTop();
        this.props.onPrev();
    }

    handleNext = (event) => {
        event.preventDefault();
        this.bringToTop();
        this.props.onNext();
    }

    handleClose = (event) => {
        event.preventDefault();
        this.props.onClose();
    }

    handleDirectionForm = (event) => {
        event.preventDefault();

        this.handleOpenGoogleMaps(event, event.target.origin.value);

        this.setState({
            direction: {
                ...this.state.direction,
                origin: event.target.origin.value
            }
        })

    }

    handleOpenGoogleMaps = (event, address) => {
        event.preventDefault();

        const {member} = this.props;
        try {
            window.open('https://www.google.com/maps/dir/' + address + '/' + member.member_latitude + ',' + member.member_longitude + '/');
        } catch (error) {

        }
    }

    renderCategories = (categories) => {

        let list = [];

        categories.forEach(category => {
            let cat = this.props.categories.find((gCategory, index) => {
                if (parseInt(gCategory.category_id) === parseInt(category)) {
                    return true;
                }
                return false;
            });

            if (cat) {
                list.push(
                    <li>
                        <img src={'/wp-content/plugins/dsz-wordpress-list/map/build/' + getIcon(cat.category_slug)}
                             width={40} alt={cat.category_title}/> {cat.category_title}
                    </li>
                )
            }

        })

        return list;
    }

    render() {

        const {
            member,
            selected,
            total
        } = this.props;

        let categories = member.member_category_ids.split(',');

        return (
            <div className="memberdetail-wrapper">
                <div className="memberdetail">
                    <div className="memberdetail-header">
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-xs-3 col-md-3 memberdetail-nav-right">
                                    <button onClick={this.handlePrev} className="switch-button"><i className="fa fa-angle-left"/></button>
                                    {
                                        (this.props.version === 'DESKTOP')
                                        ?
                                            <button onClick={this.handleSidebarDesktop}>
                                                {
                                                    (this.state.sidebaropen === true) ? <><i className="fas fa-filter" /> Vollbild</>
                                                        : <><i className="fas fa-filter" /> Filterung</>
                                                }
                                            </button>
                                        :
                                            <></>
                                    }

                                </div>
                                <div className="col-xs-4 col-md-6 text-center">
                                    {(selected + 1)} von {total}
                                </div>
                                <div className="col-xs-5 col-md-3 text-right memberdetail-nav-right">
                                    <button onClick={this.handleClose} className="switch-button">
                                        <i className="fa fa-close"/>
                                    </button>
                                    <button onClick={this.handleNext} className="switch-button">
                                        <i className="fa fa-angle-right"/>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="memberdetail-content">

                        <div className="member-profile-header"
                             style={{
                                 // eslint-disable-next-line
                                 backgroundImage: 'url(' + (getApiUrl() + 'imageout/' + member.coverimage_id + '/h_' + member.member_post_name + '.jpg?width=1920&height=600') + ')'
                             }}
                        >
                            <div className="member-profile-header-overlay"></div>
                            <div className="container-fluid">
                                <div className="row">
                                    <div className="col-xs-12">
                                        <div className="member-profile-image">
                                            <img
                                                src={getApiUrl() + 'imageout/' + member.profileimage_id + '/l_' + member.member_post_name + '.jpg?width=240&height=240'}
                                                loading="lazy"
                                                width="240" height="240" alt={member.member_post_title}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>

                        <div className="member-profile-section-1">
                            <div className="container-fluid">
                                <div className="row">
                                    <div className="col-xs-12 col-md-6 col-lg-4">
                                        <h1 dangerouslySetInnerHTML={{__html: member.member_post_title}}/>
                                        <h2 dangerouslySetInnerHTML={{__html: member.member_tagline2}}/>
                                    </div>
                                    <div className="col-xs-12 col-md-6 col-lg-3">
                                        <div className="member-profile-header-buttons-dep">
                                            <ul>
                                                {this.renderCategories(categories)}
                                            </ul>
                                        </div>
                                    </div>
                                    <div className="col-xs-12 col-md-12 col-lg-5">
                                        <div className="member-profile-header-tabs">
                                            <ul>
                                                <li className={(this.state.activeView === VIEW_LETTER_A) ? 'active' : ''}>
                                                    <a href="#!"
                                                       onClick={(event) => this.handleChangeView(event, VIEW_LETTER_A)}>Klinik
                                                        bzw. Praxis</a>
                                                </li>
                                                {
                                                    (this.state.layers.secondLayer.length > 0)
                                                    ? <li className={(this.state.activeView === VIEW_LETTER_B) ? 'active' : ''}>
                                                            <a href="#!"
                                                               onClick={(event) => this.handleChangeView(event, VIEW_LETTER_B)}>Über
                                                                den Arzt</a>
                                                        </li>
                                                    : <Fragment />

                                                }

                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="memberlist-content">
                            <div className="container-fluid">

                                {
                                    (this.state.activeView === VIEW_LETTER_A)
                                        ?
                                        <Fragment>
                                            <div className="mansory-container">

                                                {
                                                    this.state.layers.firstLayer.map(layerItem => {
                                                        return (
                                                            <div className="member-profile-card">
                                                                <div className="member-profile-card-head">
                                                                    <div className="member-profile-card-title">
                                                                        <h5>{layerItem.title}</h5>
                                                                    </div>
                                                                </div>
                                                                <div className="member-profile-card-body">
                                                                    {
                                                                        (layerItem.direct === true)
                                                                        ? <Fragment>{layerItem.content}</Fragment>
                                                                        : <div
                                                                                className="table profile-table"
                                                                                dangerouslySetInnerHTML={{__html: layerItem.content}}/>
                                                                    }
                                                                </div>
                                                            </div>
                                                        )
                                                    })
                                                }


                                                <div className="member-profile-card">
                                                    <div className="member-profile-card-head">
                                                        <div className="member-profile-card-title">
                                                            <h5>Anfahrt</h5>
                                                        </div>
                                                    </div>
                                                    <div
                                                        className="member-profile-card-body member-profile-card-body-fix-padding member-profile-card-body-map">

                                                        <form onSubmit={this.handleDirectionForm}>
                                                            <div className="container-fluid mb-20">
                                                                <div className="row">
                                                                    <div className="col-sm-8">
                                                                        <input
                                                                            type="text"
                                                                            name="origin"
                                                                            className="w-100"
                                                                            placeholder={'Ihre Adresse'}
                                                                        />
                                                                    </div>
                                                                    <div className="col-sm-4">
                                                                        <button type={'submit'}
                                                                                className="w-100">Route
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                        </form>

                                                        <div className="container-fluid">
                                                            <div className="row">
                                                                <div className="col-sm-12">

                                                                    <GoogleMap
                                                                        id={'gmap-memberdetail'}
                                                                        mapContainerStyle={{
                                                                            width: '100%',
                                                                            height: '400px'
                                                                        }}
                                                                        center={{
                                                                            lat: parseFloat(member.member_latitude),
                                                                            lng: parseFloat(member.member_longitude)
                                                                        }}
                                                                        zoom={10}
                                                                        onLoad={(map) => {
                                                                            this.setState({
                                                                                map
                                                                            })
                                                                        }}
                                                                        options={{
                                                                            // these following 7 options turn certain controls off see link below
                                                                            streetViewControl: false,
                                                                            scaleControl: false,
                                                                            mapTypeControl: false,
                                                                            panControl: false,
                                                                            zoomControl: true,
                                                                            rotateControl: false,
                                                                            fullscreenControl: false
                                                                        }}
                                                                    >

                                                                        <Marker
                                                                            key={member.member_id}
                                                                            position={{
                                                                                lat: parseFloat(member.member_latitude),
                                                                                lng: parseFloat(member.member_longitude)
                                                                            }}
                                                                            title={member.post_title}
                                                                            id={'ABC'}
                                                                            /*
                                                                            icon={{
                                                                                url: getLiveApiUrl() + 'imageout/' + member.profileimage_id + '?width=50&height=50',
                                                                                optimized: false
                                                                            }}
                                                                             */
                                                                        >
                                                                        </Marker>
                                                                    </GoogleMap>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>


                                                <div className="member-profile-card">
                                                    <div className="member-profile-card-head">
                                                        <div className="member-profile-card-title">
                                                            <h5>Kontakt</h5>
                                                        </div>
                                                    </div>
                                                    <div className="member-profile-card-body">
                                                        <table className="table profile-table">
                                                            {
                                                                (member.member_location)
                                                                    ?
                                                                    <tr>
                                                                        <td width="30"><i className="fa fa-map"></i>
                                                                        </td>
                                                                        <td><a
                                                                            href={'https://www.google.com/maps/place/' + member.member_location + '/'}
                                                                            target={'_blank'}
                                                                            rel="noreferrer"
                                                                        >{member.member_location}</a></td>
                                                                    </tr>
                                                                    :
                                                                    <Fragment/>
                                                            }
                                                            {
                                                                (member.member_email)
                                                                    ?
                                                                    <tr>
                                                                        <td width="30"><i
                                                                            className="fa fa-envelope"></i>
                                                                        </td>
                                                                        <td><a
                                                                            href={'mailto:' + member.member_email}>{member.member_email}</a>
                                                                        </td>
                                                                    </tr>
                                                                    :
                                                                    <Fragment/>
                                                            }
                                                            {
                                                                (member.member_phone)
                                                                    ?
                                                                    <tr>
                                                                        <td width="30"><i
                                                                            className="fa fa-phone"></i></td>
                                                                        <td><a
                                                                            href={'tel:' + member.member_phone}>{member.member_phone}</a>
                                                                        </td>
                                                                    </tr>
                                                                    :
                                                                    <Fragment/>
                                                            }
                                                            {
                                                                (member.member_website)
                                                                    ?
                                                                    <tr>
                                                                        <td width="30"><i
                                                                            className="fa fa-globe"></i></td>
                                                                        <td><a href={member.member_website}
                                                                               rel="noreferrer" target={'_blank'}>Zur
                                                                            Website</a></td>
                                                                    </tr>
                                                                    :
                                                                    <Fragment/>
                                                            }

                                                        </table>
                                                    </div>
                                                </div>


                                                {
                                                    (member.member_treatment_focus && member.member_treatment_focus.length > 8)
                                                        ?
                                                        <div className="member-profile-card">
                                                            <div className="member-profile-card-head">
                                                                <div className="member-profile-card-title">
                                                                    <h5>Behandlungsschwerpunkte</h5>
                                                                </div>
                                                            </div>
                                                            <div className="member-profile-card-body">
                                                                <div
                                                                    dangerouslySetInnerHTML={{__html: member.member_treatment_focus}}/>
                                                            </div>
                                                        </div>
                                                        :
                                                        <Fragment/>
                                                }

                                                {
                                                    (member.member_therapeutic_services && member.member_therapeutic_services.length > 8)
                                                        ?
                                                        <div className="member-profile-card">
                                                            <div className="member-profile-card-head">
                                                                <div className="member-profile-card-title">
                                                                    <h5>Therapeutische Leistungen</h5>
                                                                </div>
                                                            </div>
                                                            <div className="member-profile-card-body">
                                                                <div
                                                                    dangerouslySetInnerHTML={{__html: member.member_therapeutic_services}}/>
                                                            </div>
                                                        </div>
                                                        :
                                                        <Fragment/>
                                                }


                                            </div>
                                        </Fragment>
                                        :
                                        <Fragment>

                                            <div className="mansory-container">

                                                {
                                                    this.state.layers.secondLayer.map((layerItem, index) => {
                                                        return (
                                                            <div ref={layerItem.reference} className={'member-profile-card ' + (typeof(layerItem.accordion) !== "undefined" ? ' member-profile-card-accordion ' : '') + ' ' + (this.state.accordion.secondLayer.includes(index) ? ' member-profile-card-long' : '')}>
                                                                <div className="member-profile-card-head">
                                                                    <div className="member-profile-card-title">
                                                                        <h5>{layerItem.title}</h5>
                                                                    </div>
                                                                </div>
                                                                <div className="member-profile-card-body">
                                                                    <div
                                                                        className="table profile-table member_long_card"
                                                                        dangerouslySetInnerHTML={{__html: layerItem.content}}/>
                                                                </div>
                                                                {
                                                                    (this.state.accordion.secondLayer.includes(index))
                                                                        ? <a href="#!" className="btn-link readmore" onClick={(e) => this.showLess(e, 'secondLayer', index)}>Weniger anzeigen</a>
                                                                        : <a href="#!" className="btn-link readmore" onClick={(e) => this.showMore(e, 'secondLayer', index)}>Mehr anzeigen</a>
                                                                }
                                                            </div>
                                                        )
                                                    })
                                                }


                                            </div>

                                        </Fragment>
                                }


                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default MemberDetail;
